"use client";

import { useEffect, useState } from "react";

interface IpInfo {
  ip: string;
  isp: string;
  status: "Protected" | "Unprotected";
}

export function IpStatusBanner() {
  const [ipInfo, setIpInfo] = useState<IpInfo | null>(null);
  const [loading, setLoading] = useState(true);
  const [mounted, setMounted] = useState(false);

  // Only render after client-side mount
  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    async function fetchIpInfo() {
      try {
        const response = await fetch("/api/ip-info");
        if (response.ok) {
          const data = await response.json();
          setIpInfo(data);
        }
      } catch (error) {
        console.error("Failed to fetch IP info:", error);
      } finally {
        setLoading(false);
      }
    }

    fetchIpInfo();
  }, []);

  // Don't render on server or before client mount
  if (!mounted) {
    return null;
  }

  const isProtected = ipInfo?.status === "Protected";

  return (
    <div className="fixed top-0 left-0 right-0 z-50 w-full bg-foreground text-background py-1.5 px-2 text-center text-xs sm:text-sm font-medium">
      <div className="container mx-auto flex items-center justify-center gap-2 sm:gap-4">
        {loading ? (
          <span>Loading...</span>
        ) : ipInfo ? (
          <>
            <span className="hidden sm:inline">Your IP: {ipInfo.ip}</span>
            <span className="sm:hidden">{ipInfo.ip}</span>
            <span className="hidden sm:inline">•</span>
            <span className="hidden md:inline">Your ISP: {ipInfo.isp}</span>
            <span className="hidden sm:inline md:hidden">{ipInfo.isp}</span>
            <span className="hidden sm:inline">•</span>
            <span className="hidden sm:inline">Your Status:{" "}</span>
            <span
              className={
                isProtected
                  ? "text-green-400 font-semibold"
                  : "text-red-400 font-semibold"
              }
            >
              {ipInfo.status}
            </span>
          </>
        ) : (
          <span>Unable to load IP information</span>
        )}
      </div>
    </div>
  );
}
